import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../../shared/Typography';
import Icon from '../../shared/Icon';
import CodeBlock from './CodeBlock';

// icons
const sizes = ['x-small', 'small', 'regular', 'medium', 'large', 'x-large'];
const set1 = ['eye-open', 'eye-closed', 'cal', 'steth', 'file', 'pin'];
const set2 = ['face', 'camera--purple', 'id', 'hello', 'mobile', 'desktop'];
const set3 = ['download', 'location', 'arrow-forward', 'arrow-back',
  'zoom-in', 'zoom-out', 'check', 'check-green'];
const set4 = ['rotate', 'shopping-cart', 'close-gray', 'arrow-down', 'search'];
const set5 = ['lock-closed', 'lock-open', 'lock-mid', 'lock-success'];
const set6 = ['pending', 'ellipse'];
const set7 = ['warning', 'alert'];
const set8 = ['rosetta-neutral'];
const set9 = ['close', 'camera', 'rx', 'record', 'clinical', 'imaging', 'lab'];
const set10 = ['error', 'download', 'arrow-forward', 'arrow-back', 'zoom-in', 'zoom-out', 'rotate'];

const Icons = () => {
  const { t } = useTranslation('icons');
  return (
    <React.Fragment>

      <Text h2 className='pattern-library__section-title'>{t('icons')}</Text>

      <CodeBlock>{t('info')}</CodeBlock>

      <Text h3 className='pattern-library__title'>{t('diff_sizes')}</Text>
      {sizes.map((size) => <Icon size={size} name='cal' className='pattern-library__icon' />)}

      <Text h3 className='pattern-library__title'>{t('dark_colour_icons')}</Text>
      <div>{set1.map((item) => <Icon size='x-large' name={item} className='is-purple pattern-library__icon' />)}</div>
      <div>{set2.map((item) => <Icon size='x-large' name={item} className='is-purple pattern-library__icon' />)}</div>
      <div>{set3.map((item) => <Icon size='x-large' name={item} className='is-purple pattern-library__icon' />)}</div>
      <div>{set4.map((item) => <Icon size='x-large' name={item} className='is-purple pattern-library__icon' />)}</div>
      <div>{set5.map((item) => <Icon size='x-large' name={item} className='is-purple pattern-library__icon' />)}</div>
      <div>{set6.map((item) => <Icon size='x-large' name={item} className='is-purple pattern-library__icon' />)}</div>
      <div>{set7.map((item) => <Icon size='x-large' name={item} className='is-purple pattern-library__icon' />)}</div>
      <div>{set8.map((item) => <Icon size='x-large' name={item} className='is-purple pattern-library__icon' />)}</div>

      <Text h2 className='pattern-library__section-title'>{t('icons_light')}</Text>
      <div>
        {set9.map((item) => <Icon size='x-large' name={item} className='is-white pattern-library__icon--light' />)}
      </div>
      <div>
        {set10.map((item) => <Icon size='x-large' name={item} className='is-white pattern-library__icon--light' />)}
      </div>
    </React.Fragment>
  );
};

export default Icons;



// WEBPACK FOOTER //
// ./src/components/pages/pattern-library/icons.js